module.exports = "https://trybtryb-legacy.web.app/img/oval-mobile.073cc10b.svg";